import { useState, useEffect, useCallback } from "react";
import { httpRequest } from "../../../../../ui-utils/api";
import { backendHosts, apiUrl } from "../../../../../ui-utils/apiConfig";
import { withStyles } from "@material-ui/core/styles";
import styles from "../OperationsStyles";
import {
  Typography,
  Button,
  Modal,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Grid,
  Box,
  Paper,
} from "@mui/material";
import { format } from "date-fns";
import dayjs from "dayjs";
import { DataGrid } from "@mui/x-data-grid";
import {IconButton, Tooltip } from "@material-ui/core";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { Block, Download, FileDownloadOff } from "@mui/icons-material";
import Swal from "sweetalert2";
import EditIcon from "@mui/icons-material/Edit";
import axios from "axios";
import CloseIcon from "@mui/icons-material/Close";
import Filter from "../Filters/Fields";

const AccountClosure =({classes})=>{



 const style = {
    position: "absolute !important",
    top: "50% !important",
    left: "50% !important",
    transform: "translate(-50%, -50%) !important",
    width: "40% !important",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    borderRadius: "15px !important",
    "@media only screen and (max-width: 1650px)": {
      width: "80% !important",
    },
  };

  const fontM = {
    fontFamily: "cardiuma-M !important",
  };

  const fontR = {
    fontFamily: "cardiuma-regular !important",
  };

  const [accountClosureData, setAccountClosureData] = useState([]);
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 10,
    page: 0,
  });
  const [editModal, setEditModal] = useState(false);
  const [error, setError] = useState("");
  const [userData, setUserData] = useState({});
  const [stage, setStage] = useState("signed");
 
  const [hide, setHide] = useState(true);
  const [checkboxToggle, setCheckboxToggle] = useState("signed");

  const [filteredData, setFilteredData] = useState([]);
  const [status, setStatus] = useState(false);
  const [Fdate, setFdate] = useState(dayjs().subtract(3, 'month').startOf('month'))
  const [Tdate, setTdate] = useState(dayjs())
  const [fterror, setFTError] = useState("")

  useEffect(() => {
    const today = dayjs();
         const threeMonthsAgo = today.subtract(3, 'month').startOf('month');
   
         setFdate(threeMonthsAgo);
         setTdate(today);

    const payload = { 
      fdate: threeMonthsAgo.format("YYYY-MM-DD"),
      tdate: today.format("YYYY-MM-DD"),
    };
    console.log('UE',payload)
      fetchAccountClosureData(payload);
    }
  , []);

   const handleFDate = useCallback((newValue) => {
        setFdate(dayjs(newValue).format('YYYY-MM-DD'))
      }, [])
    
      const handleTDate = useCallback((newValue) => {
        setTdate(dayjs(newValue).format('YYYY-MM-DD'))
      }, [])

    const handleFormSubmit = async (e) => {
        e.preventDefault()
        if (Fdate === null || Tdate === null) {
            setFTError("Both From Date and To Date required *")
            return
        }
        const formData = { fdate: Fdate, tdate: Tdate }
        await fetchAccountClosureData(formData)
        setFTError("")
        setStatus("signed")
        setPaginationModel({
            pageSize: 10,
            page: 0,
        })
    }

  
   const handleReset = async () => {
   
    const today = dayjs();
    const threeMonthsAgo = today.subtract(3, 'month').startOf('month');
    setFdate(threeMonthsAgo);
    setTdate(today);
    setStatus("signed")
    setFTError("")
    setPaginationModel({
      pageSize: 10,
      page: 0,
    })

    const payload = { 
      fdate: threeMonthsAgo.format("YYYY-MM-DD"),
      tdate: today.format("YYYY-MM-DD"),
    };
    await fetchAccountClosureData(payload)
  }


  const fetchAccountClosureData = async (payload) => {
    try {
      // const response = await axios.post(
      //   `http://localhost:5002/accountclosure/accountclosure-list`,
      //     payload // { fdate, tdate }
      // );
     const response = await httpRequest({
       endPoint: `${backendHosts.BACK_OFFICE}${apiUrl.acList}`,
        method: "post",
        instance: "instanceOne",
       requestBody: payload,
      });

      console.log('res',response)
      if (response) {
        const allData = response
        console.log("cd",allData)
        const accountclosureFilter = allData.filter(
          (item) => item.stage == checkboxToggle
        );

        setAccountClosureData(allData);
        setFilteredData(accountclosureFilter);
      } else {
        console.log("Error in LearningCentre List API", response.data);
      }
    } catch (error) {
      console.log("Error in LearningCentre List API", error);
    }
  };

  console.log(accountClosureData);

  const handleSaveStatusChange = async (user) => {
    const userName=localStorage.getItem("username")
    const now = new Date();
    const formattedDate = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;


    if(stage === 'approved'){
    try {
      // const response = await axios.post('http://localhost:5002/accountclosure/accountclosure-approve', { accountno:user.accountno,closedby:userName,closed_date:formattedDate });
       const response = await httpRequest({
         endPoint: `${backendHosts.BACK_OFFICE}${apiUrl.acApprove}`,
        method: "post",
        instance: "instanceOne",
         requestBody: { accountno: user.accountno, closedby: userName, closed_date: formattedDate },
      });

      console.log("approve response",response)

      if (response) {
          const today = new Date();
          const threeMonthsAgo = new Date(today);
          threeMonthsAgo.setMonth(today.getMonth() - 3);
          threeMonthsAgo.setDate(1);
          const fdate = threeMonthsAgo.toISOString().split("T")[0];
          const tdate = today.toISOString().split("T")[0];
          const payload = { fdate, tdate };
          await fetchAccountClosureData(payload)

        setEditModal(false);
        Swal.fire({
          html: `<h2 style="font-size: 24px; font-family: 'cardiuma-regular' !important;">
    Updated Successfully! .
   </h2>`,
              icon: "success",
              willOpen: () => {
                  const swalContainer = document.querySelector(".swal2-container");
                  if (swalContainer) {
                      swalContainer.style.zIndex = "2000";
                  }
              },
          });
        
      
      } else {
        alert(response.data.message || 'Failed to update status.');
      }
    } catch (error) {
      console.error('Error updating status:', error);
      alert(error.response?.data?.message || 'Something went wrong.');
    }
  }

  if(stage === 'rejected'){
     try {
      // const response = await axios.post('http://localhost:5002/accountclosure/accountclosure-reject', { accountno:user.accountno,closedby:userName,closed_date:formattedDate });
      const response = await httpRequest({
        endPoint: `${backendHosts.BACK_OFFICE}${apiUrl.acReject}`,
        method: "post",
        instance: "instanceOne",
        requestBody: { accountno: user.accountno, closedby: userName, closed_date: formattedDate },
      });

      console.log('reject response',response)

       if (response) {
         const today = new Date();
         const threeMonthsAgo = new Date(today);
         threeMonthsAgo.setMonth(today.getMonth() - 3);
         threeMonthsAgo.setDate(1);
         const fdate = threeMonthsAgo.toISOString().split("T")[0];
         const tdate = today.toISOString().split("T")[0];
         const payload = { fdate, tdate };
         await fetchAccountClosureData(payload)

         setEditModal(false);
         Swal.fire({
           html: `<h2 style="font-size: 24px; font-family: 'cardiuma-regular' !important;">
      Updated Successfully!
      </h2>`,
           icon: "success",
           willOpen: () => {
             const swalContainer = document.querySelector(".swal2-container");
             if (swalContainer) {
               swalContainer.style.zIndex = "2000";
             }
           },
         });
      
      } else {
        alert(response.data.message || 'Failed to update status.');
      }
    } catch (error) {
      console.error('Error updating status:', error);
      alert(error.response?.data?.message || 'Something went wrong.');
    }
  }
  };

  const handlecheckboxChange = (e, str) => {
    setCheckboxToggle(str);
    let accountclosureFilterData = [];
    if (str === "signed" && e.target.checked) {
      accountclosureFilterData = accountClosureData.filter(
        (item) => item.stage == "signed"
      );
      console.log("Sorted final data", accountclosureFilterData);
      setFilteredData(accountclosureFilterData);
    } else if (str === "initiated" && e.target.checked) {
      accountclosureFilterData = accountClosureData.filter(
        (item) => item.stage == "initiated"
      );
      console.log("Sorted final data", accountclosureFilterData);
      setFilteredData(accountclosureFilterData);
    }
     else if (str === "approved" && e.target.checked) {
      accountclosureFilterData = accountClosureData.filter(
        (item) => item.stage == "approved"
      );
      console.log("Sorted final data", accountclosureFilterData);
      setFilteredData(accountclosureFilterData);
    }
     else if (str === "rejected" && e.target.checked) {
      accountclosureFilterData = accountClosureData.filter(
        (item) => item.stage == "rejected"
      );
      console.log("Sorted final data", accountclosureFilterData);
      setFilteredData(accountclosureFilterData);
    }
  };

  const columns = [
    {
      field: "createdon",
      headerName: "Date",
      align: "center",
      headerAlign: "center",
      flex: 1,
      valueFormatter: (params) => format(new Date(params), "yyyy-MM-dd"),
    },
    {
      field: "accountno",
      headerName: "Account No",
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "name",
      headerName: "Name",
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "emailid",
      headerName: "Email",
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "mobileno",
      headerName: "Phone no",
      type: "number",
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "closed_date",
      headerName: "Action Date",
      align: "center",
      headerAlign: "center",
      flex: 1,
      valueFormatter: (params) => {
        const date = params;
        return date ? format(new Date(date), "yyyy-MM-dd") : "";
      },
    },
    {
      field: "closedby",
      headerName: "Action By",
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "stage",
      headerName: "Stage",
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "reason",
      headerName: "Reason",
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
   
    {
      field: "actions",
      headerName: "Action",
      align: "center",
      headerAlign: "center",
      flex: 1,
      renderCell: (params) =>
        (params.row.stage !== "closed" ) ? ( // Only render the button if stage is not "closed"
          <IconButton onClick={() => handleEditModal(params.row)}>
            <EditIcon />
          </IconButton>
        ) : null,
    },
  ];

  const handleEditModal = (row) => {
    setEditModal(true);
    setUserData(row);
  };

  const handleClose = () => {
    setEditModal(false);
    setUserData({});
    setError("");
    setStage("initiated");
  };



    
  const downloadDocument = async (user) => {
  try {

    console.log("userrr",user)
    // const response = await axios.get(
    //   `http://localhost:5002/accountclosure/accountclosure-eSignDownload/${user.id}`
    // );

      const response = await httpRequest({
        endPoint: `${backendHosts.BACK_OFFICE}${apiUrl.acEsignDownload}/${user.id}`,
        method: "get",
        instance: "instanceOne"
      });

    console.log("acEsignDownloadres",response)

    if (response?.status === 200 && response?.data) {
      downloadPDF(response?.data, response?.filename);
    } else {
      console.error('Unexpected response structure:', response);
    }
  } catch (error) {
    if (error.response?.status === 404) {
      console.error('Document not found (404)', error);
    } else {
      console.error('Error downloading document:', error);
    }
  }
};

  const downloadDocumentcmr = async (user) => {
  try {
    // const response = await axios.get(
    //   `http://localhost:5000/accountclosure/accountclosure-cmrDownload/${user.id}`
    // );

     const response = await httpRequest({
        endPoint: `${backendHosts.BACK_OFFICE}${apiUrl.acCmrDownload}/${user.id}`,
        method: "get",
        instance: "instanceOne"
      });

    console.log("acCmrDownload",response)

     if (response.status === 200 && response?.data) {
      downloadPDF(response.data, response?.filename);
    }   
    else {
      console.error('Unexpected response structure:', response);
    }
  } catch (error) {
    if (error.response?.status === 404) {
      console.error('Document not found (404)', error);
    } else {
      console.error('Error downloading document:', error);
    }
  }
};

const downloadPDF = (base64Pdf, filename) => {
  const linkSource = `data:application/pdf;base64,${base64Pdf}`;
  const downloadLink = document.createElement("a");
  downloadLink.href = linkSource;
  downloadLink.download = filename || "document.pdf";
  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink); // Clean up
};

    return  <>
        <Box
            sx={{
                display: "flex",
                flexWrap: "wrap", // wrap on smaller screens
                justifyContent: "space-between",
                alignItems: "center",
                gap: 2, // spacing between items
                mb: 2,
            }}
        >
            {/* Date Filter Form */}
            <form className={classes.fnoFormDateField} onSubmit={handleFormSubmit} style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                        label="From"
                        format="DD-MM-YYYY"
                        InputLabelProps={{ shrink: true }}
                        InputProps={{ className: classes.input }}
                        className={classes.datePicker}
                        value={Fdate}
                        onChange={handleFDate}
                    />
                    <DatePicker
                        label="To"
                        format="DD-MM-YYYY"
                        InputLabelProps={{ shrink: true }}
                        InputProps={{ className: classes.input }}
                        className={classes.datePicker}
                        value={Tdate}
                        onChange={handleTDate}
                    />
                </LocalizationProvider>

          <Button type="submit" style={{
            width: '100px',
            height: '34px',
            margin: '4px 0 1px 12px',
            color: '#fff',
            backgroundColor: '#F44748',
            fontFamily: 'cardiuma-regular',
            fontSize: '11px',
            fontStyle: 'normal',
            marginRight: 2
          }}>Submit</Button>

          <Button onClick={handleReset} style={{
            width: '100px',
            height: '34px',
            margin: '4px 0 1px 12px',
            color: '#fff',
            backgroundColor: '#F44748',
            fontFamily: 'cardiuma-regular',
            fontSize: '11px',
            fontStyle: 'normal',
            marginRight: 2
          }}>Reset</Button>

          </form>

            {/* Typography + Filter */}
            <Box sx={{ display: 'flex-end', alignItems: 'center', gap: 2 ,justifyContent:'center',mt:4}}>
               
                <Filter
                    setHide={setHide}
                    checkboxToggle={checkboxToggle}
                    handlecheckboxChange={handlecheckboxChange}
                    setStatus={setStatus}
                />
            </Box>

           
        </Box>
             {fterror && <Typography color="error" mb={3} ml={2}>{fterror}</Typography>}
        {/* <Typography sx={{ color: "#fff !important", whiteSpace: 'nowrap' ,mb:"20px !important",ml:"30px !important"}}>
            Total records {accountClosureData.length}
        </Typography> */}

          <Paper
            className={classes.horizantalTablayout}
            sx={{ height: "80vh" }}
          >
            <DataGrid
              rows={filteredData}
              columns={columns}
              paginationModel={paginationModel}
              onPaginationModelChange={setPaginationModel}
              pageSizeOptions={[10, 25, 50]}
              className={classes.customDataGrid}
              sx={{
                "--DataGrid-containerBackground": "#131E2E",
                "--DataGrid-rowBorderColor": "#000",
                border: 0,
                width: "100% !important",
              }}
              pagination
              getRowId={(row) => row.id}
            />
          </Paper>

          <Modal
            open={editModal}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            userData={userData}
          >
            <Box sx={{ ...style, padding: "20px" }}>
              {" "}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  textAlign: "center",
                  width: "100%",
                  position: "relative",
                }}
              >
                <Typography
                  id="modal-modal-title"
                  variant="h6"
                  component="h2"
                  sx={{
                    fontFamily: "cardiuma-M",
                    fontWeight: "bold",
                  }}
                >
                  Account Closure Details
                </Typography>

             
                <Button
                  onClick={handleClose}
                  sx={{
                    minWidth: "unset",
                    padding: "0",
                    position: "absolute",
                    right: 0,
                    top: 0,
                  }}
                >
                  <CloseIcon style={{ color: "red" }} />
                </Button>
              </Box>
          
              <Grid
                container
                sx={{
                  paddingTop: "20px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {[
                  { label: "Email", value: userData.emailid },
                  { label: "Phone no", value: userData.mobileno },
                  { label: "Account No", value: userData.accountno },
                  {
                    label: "Date",
                    value: userData.createdon
                      ? dayjs(userData.createdon).format("YYYY-MM-DD")
                      : "",
                  },

                  { label: "Reason", value: userData.reason },
                  ...(userData.stage !== "initiated"
                                  ? [
                                    {
                                      label: "Esigned document",
                                      value: (
                                        <Tooltip title={`${userData.filenameesign}` || "No document"} arrow>
                                          <IconButton
                                            onClick={() => downloadDocument(userData)}
                                            disabled={!userData.filenameesign} // Disable if no document is available
                                          >
                                            {userData?.filenameesign ? (
                                              <Download sx={{ color: "#42a0f7 !important" }} />
                                            ) : (
                                              <FileDownloadOff sx={{ color: "#ccc !important" }} /> // gray icon when disabled
                                            )}
                                          </IconButton>
                                        </Tooltip>
                                      ),
                                    },
                                    ]
                                  : []),

                  ...(userData.stage !== "initiated"
                                  ? [
                                    {
                                      label: "Cmr Copy document",
                                      value: (
                                        <Tooltip title={`${userData.filenamecmr}.pdf` || "No document"} arrow>
                                          <IconButton
                                            onClick={() => downloadDocumentcmr(userData)}
                                            disabled={!userData.filenamecmr} // Disable if no document is available
                                          >
                                             {userData?.filenamecmr ? (
                                              <Download sx={{ color: "#42a0f7 !important" }} />
                                            ) : (
                                              <FileDownloadOff sx={{ color: "#ccc !important" }} /> // gray icon when disabled
                                            )}
                                          </IconButton>
                                        </Tooltip>
                                      ),
                                    },
                                    ]
                                  : []),
                  ...(checkboxToggle === "signed"
                    ? [
                      {
                        label: "Stage",
                        value:
                          <Grid style={{ marginLeft: "0px", borderRadius: "5px" }}>
                            <FormControl size="small" style={{ width: "50%" }}>
                              <InputLabel
                                // className={classes.inputColor}
                                id="demo-select-small-label"
                                shrink={true}
                              >
                                Stage
                              </InputLabel>
                              <Select
                                // className={classes.select}
                                labelId="demo-select-small-label"
                                id="demo-select-small"
                                value={userData.stage} // Set default from userData.stage
                                label="Select"
                                onChange={(e) => {
                                  setUserData(prev => ({ ...prev, stage: e.target.value }));
                                  setStage(e.target.value); // Keep if needed elsewhere
                                }}
                                MenuProps={{
                                  PaperProps: {
                                    style: {
                                      top: "50px",
                                    },
                                  },
                                }}
                              >
                                <MenuItem className={classes.intSelText} value="signed">
                                  Signed
                                </MenuItem>
                                <MenuItem className={classes.intSelText} value="approved">
                                  Approve
                                </MenuItem>
                                <MenuItem className={classes.intSelText} value="rejected">
                                  Reject
                                </MenuItem>
                              </Select>
                            </FormControl>
                          </Grid>

                      }]
                    : []),
,
                ].map((item, index) => (
                  <Grid container key={index} sx={{ marginBottom: "16px" }}>
                    <Grid
                      item
                      lg={4}
                      sx={{
                        textAlign: "right",
                        paddingRight: "20px",
                        fontWeight: "bold",
                        fontFamily: "cardiuma-M",
                        paddingLeft: "20px",
                      }}
                    >
                      <Typography sx={{ fontFamily: "cardiuma-M" }}>
                        {item.label}:
                      </Typography>
                    </Grid>

                    <Grid
                      item
                      lg={8}
                      sx={{
                        wordWrap: "break-word",
                        whiteSpace: "pre-wrap",
                        paddingLeft: "20px",
                      }}
                    >
                      {typeof item.value === "string" ||
                      typeof item.value === "number" ? (
                        <Typography sx={{ fontFamily: "cardiuma-regular" }}>
                          {item.value || "\u00A0"}
                        </Typography>
                      ) : (
                        item.value // Render the Select component directly
                      )}
                    </Grid>
                  </Grid>
                ))}
              </Grid>
              <Grid
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  paddingRight: "50px",
                  paddingBottom: "10px",
                }}
              >
                {checkboxToggle === "signed" &&
                <Button
                  onClick={() => handleSaveStatusChange(userData)}
                  sx={{
                    fontFamily: "cardiuma-regular",
                    color: "#ffffff",
                    background: "#F44748",
                    width: "80px",
                    height: "35px",
                    "&:hover": {
                      background: "#F44748", // Keep the same color on hover
                    },
                    "&.Mui-disabled": {
                      background: "#D3D3D3", // Custom color for disabled state
                      color: "#ffffff", // Keep the text color
                    },
                  }}
                  disabled={userData.stage === "signed"}
                >
                  Save
                </Button>}
              </Grid>
            </Box>
          </Modal>
        </>
}

export default withStyles(styles)(AccountClosure);